import { Link } from "@chakra-ui/react"
import Card from "@pathwright/ui/src/components/card/Card"
import CardBlock from "@pathwright/ui/src/components/card/CardBlock"
import Pathicon from "@pathwright/ux/src/components/pathicon/Pathicon"
import { FeatureAction, FeatureKey } from "@pathwright/graphql-client/src/generated"
import FeatureBlockContainer from "../block/FeatureBlockContainer"
import FeaturePermissionsCoverPagesForm from "../form/FeaturePermissionsCoverPagesForm"

const ManageCoverPagesFeaturePermissions = ({ card }: any) => {
  return (
    <Card card={card} title="Lab Features" noaction emphasis="secondary">
      <CardBlock paddingTop={false}>
        <FeatureBlockContainer
          featureKey={FeatureKey.LibraryCoverPages}
          featureAction={FeatureAction.CoverPagesView}
          context={null}
          description={
            <>
              Cover Pages replace About pages in your Library with a more
              attractive, engaging pitch for why someone should take a Path. Uses your existing content, so no data is lost or changed.
              <Link
                href={
                  "https://help.pathwright.com/en/articles/12417865-new-explore-cover-pages-a-fresh-way-to-showcase-your-paths"
                }
                target="_blank"
                display="inline-flex"
                alignItems="center"
                color="brand.400"
                textDecoration="underline"
                gap={0}
              >
                Learn more
                <Pathicon icon="chevron-right" size="0.8rem" />
              </Link>
            </>
          }
          to={null}
        />
        <FeaturePermissionsCoverPagesForm />
      </CardBlock>
    </Card>
  )
}

export default ManageCoverPagesFeaturePermissions
